const settingsTab: { [key: string]: number } = {
  "file_explorer": 0,
  "as_built_tab": 1,
  "as_planned_tab": 2,
  "project_settings_tab": 3,
  "general_settings_tab": 4
};

export default settingsTab;